import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
   /*///////////////////////////
/
/ GT AMERICA TYPEKIT
/
/  1. GT AMERICA STANDARD
/  2. GT AMERICA EXTENDED
/
///////////////////////////*/
/* 1. GT AMERICA STANDARD */
@font-face {
  font-family: 'GT America Standard';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-standard-light.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
@font-face {
  font-family: 'GT America Standard';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-standard-regular.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
@font-face {
  font-family: 'GT America Standard';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-standard-medium.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
/* 2. GT AMERICA EXTENDED */
@font-face {
  font-family: 'GT America Extended';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-extended-light.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
@font-face {
  font-family: 'GT America Extended';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-extended-regular.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
@font-face {
  font-family: 'GT America Extended';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('https://a.suitsupplycdn.com/fonts/gt-america/gt-america-extended-medium.woff2') format('woff2');
  mso-generic-font-family: swiss;
  mso-font-alt: 'Arial';
}
`;
